import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "fileName", "dropZone", "submitBtn", "form", "uploadState", "loadingState"]
  static values = { maxSize: Number }

  connect() {
    this.boundPrevent = (e) => e.preventDefault()
    document.addEventListener("dragover", this.boundPrevent)
    document.addEventListener("drop", this.boundPrevent)
    this.defaultCaption = this.fileNameTarget.textContent
  }

  disconnect() {
    document.removeEventListener("dragover", this.boundPrevent)
    document.removeEventListener("drop", this.boundPrevent)
  }

  selectFile() {
    this.inputTarget.click()
  }

  fileSelected() {
    const file = this.inputTarget.files[0]
    if (!file) return

    if (file.type !== "application/pdf") {
      this.reject("That file isn't a PDF. Upload the 1099-B PDF your broker sent.")
      return
    }

    // Checked here so an oversized file never travels the wire only to be
    // rejected by the server after the upload finishes.
    if (this.hasMaxSizeValue && file.size > this.maxSizeValue) {
      this.reject(`${this.formatMb(file.size)}MB is over the ${this.formatMb(this.maxSizeValue)}MB limit — try downloading the PDF again without attachments.`)
      return
    }

    this.accept(file.name)
  }

  accept(name) {
    this.fileNameTarget.textContent = name
    this.fileNameTarget.classList.remove("text-red-500", "text-slate-400")
    this.fileNameTarget.classList.add("text-slate-800", "font-medium")
    this.submitBtnTarget.disabled = false
  }

  reject(message) {
    this.inputTarget.value = ""
    this.fileNameTarget.textContent = message
    this.fileNameTarget.classList.remove("text-slate-800", "text-slate-400", "font-medium")
    this.fileNameTarget.classList.add("text-red-500")
    this.submitBtnTarget.disabled = false
  }

  formatMb(bytes) {
    const mb = bytes / (1024 * 1024)
    return mb >= 10 ? Math.round(mb) : mb.toFixed(1)
  }

  dragEnter(e) {
    e.preventDefault()
    this.dropZoneTarget.classList.add("border-brand-400", "bg-brand-50/60")
  }

  dragLeave(e) {
    e.preventDefault()
    this.dropZoneTarget.classList.remove("border-brand-400", "bg-brand-50/60")
  }

  drop(e) {
    e.preventDefault()
    this.dropZoneTarget.classList.remove("border-brand-400", "bg-brand-50/60")
    const files = e.dataTransfer.files
    if (files.length === 0) return

    this.inputTarget.files = files
    this.fileSelected()
  }

  submit(e) {
    if (this.inputTarget.files.length === 0) {
      e.preventDefault()
      if (this.fileNameTarget.textContent === this.defaultCaption) {
        this.reject("Choose a 1099-B PDF first.")
      }
      return
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", "upload_started")
    }
    this.uploadStateTarget.classList.add("hidden")
    this.loadingStateTarget.classList.remove("hidden")
  }
}
